module.exports = require('./modules/helpers/goBack');



//////////////////
// WEBPACK FOOTER
// ./~/react-router/goBack.js
// module id = 215
// module chunks = 0